import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExternalEmail } from '../models/externalemail.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ExternalemailService {

	private svcUrl = '/ExternalEmails';

	constructor(private http: HttpClient, private url: UrlService) { }

	getExternalEmail(id: number, useImpliedSender?: boolean | null): Observable<ExternalEmail> {
		let params = new HttpParams()
			.set('UseImpliedSender', (useImpliedSender == null ? false : useImpliedSender));
		return this.http.get<ExternalEmail>(this.url.getBaseURL() + this.svcUrl + '/' + id, { params });
	}

	getExternalEmailsForBrokerId(id: number, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0  : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<ExternalEmail[]>(this.url.getBaseURL() + this.svcUrl + '/Broker/' + id, { params });
	}

	getExternalEmailsForUserId(id: string, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0  : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<ExternalEmail[]>(this.url.getBaseURL() + this.svcUrl + '/User/' + id, { params });
	}

	getFullExternalEmailsForBrokerId(id: number, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0  : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<ExternalEmail[]>(this.url.getBaseURL() + this.svcUrl + '/BrokerFull/' + id, { params });
	}

	getFullExternalEmailsForUserId(id: string, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0  : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<ExternalEmail[]>(this.url.getBaseURL() + this.svcUrl + '/UserFull/' + id, { params });
	}

	dismissExternalEmail(id: number): Observable<ExternalEmail> {
		return this.http.post<ExternalEmail>(this.url.getBaseURL() + this.svcUrl + '/Dismiss/' + id, {});
	}
}
